<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
  // import HelloWorld from './components/HelloWorld.vue'
  export default {
    name: 'app'
  }
</script>

<style>
  #app {
    height: 100%;
  }
</style>